<template>
    <div>
        <v-layout row align-center justify-space-between class="header report-header">
            <v-btn flat dark :to="'/bot/' + activeBot.code">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px" class="report-title">Session Report</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer" class="report-bot-list">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile v-for="bot in botList" :key="bot.code" @click="changeBot(bot)"
                                :class="activeBot.code === bot.code ? 'active' : ''">
                                <v-list-tile-title>{{ bot.name }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-container fluid grid-list-sm>
            <v-card class="pa-1">
                <v-layout class="d-none">
                    <v-flex xs4>
                        <v-select v-model="supporter" label="Supporter" :items="supporterList" disabled />
                    </v-flex>
                    <v-flex xs4>
                        <v-select v-model="channel" label="Channel" :items="channelList" disabled />
                    </v-flex>
                    <v-flex xs4>
                        <v-select v-model="density" label="Density" :items="densityList" disabled />
                    </v-flex>
                    <v-spacer />
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12 md10>
                        <v-layout row wrap class="report-filter">
                            <v-flex xs12 sm6 md3>
                                <v-text-field v-model="supporterEmail" label="Supporter Email" @change="getData"
                                    placeholder="Email" />
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <v-select v-model="timeType" label="Time Filter" :items="timeTypeList" />
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <v-select v-model="interval" label="Interval" :items="intervalList" />
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <DatePicker v-model="fromDate" label="From Date" :max="toDate"
                                    :disabled="interval !== 'custom'" />
                            </v-flex>
                            <v-flex xs12 sm6 md2>
                                <DatePicker v-model="toDate" label="To Date" :min="fromDate" :max="today"
                                    :disabled="interval !== 'custom'" />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field v-model="customerName" label="Customer" @change="getData"
                                    placeholder="Customer name" />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-text-field v-model="cif" label="CIF" @change="getData" placeholder="CIF" />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-select v-model="topicLevel1" label="Topic Level 1" :items="topicLevel1Options"
                                    clearable />
                            </v-flex>
                            <v-flex xs12 sm6 md3>
                                <v-select v-model="topicLevel2" label="Topic Level 2" :items="topicLevel2Options"
                                    clearable :disabled="!topicLevel1" />
                            </v-flex>

                        </v-layout>
                    </v-flex>
                    <v-flex xs12 md2 class="action-buttons">
                        <v-btn color="primary" @click="getData" v-if="interval === 'custom'">Get Data</v-btn>
                        <v-btn color="primary" @click="exportExcel" :disabled="is_lock_report">Export Excel</v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card class="my-3">
                <v-data-table :items="dataTableSort" :headers="headers" :pagination.sync="pagination"
                    :total-items="total_reports" :rows-per-page-items="rowsPerPageItems">
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td v-for="header of headers" :key="header.value">
                                <span v-if="header.$value">{{ header.$value(props.item) }}</span>
                                <div v-else>
                                    <span v-if="header.value === 'conversation_id'">
                                        <a href="#" @click="handleClickConversationId(props)">
                                            <span style="padding: 0px 8px">{{ props.item[header.value] }}</span>
                                        </a>
                                    </span>

                                    <span v-else @click="handleClickConversationId">{{ props.item[header.value]
                                    }}</span>
                                </div>

                            </td>
                        </tr>
                    </template>
                    <template v-slot:headers="props">
                        <tr>
                            <th v-for="header in props.headers" :key="header.text" :class="[
                                'column sortable',
                                pagination.descending ? 'desc' : 'asc',
                                header.value === pagination.sortBy ? 'active' : ''
                            ]" @click="changeSort(header.value)">
                                <v-layout align-center style="height: 25px">
                                    <span>{{ header.text }}</span>
                                    <v-menu open-on-hover bottom offset-y left v-if="header.tooltips">
                                        <template v-slot:activator="{ on }">
                                            <i class="mdi mdi-alert-circle info-icon ml-1" v-on="on"></i>
                                        </template>
                                        <div class="header-tooltips">
                                            <v-layout align-start>
                                                <v-icon small dark color="#4977EE" class="mr-1">
                                                    mdi-alert-circle
                                                </v-icon>
                                                {{ header.tooltips }}
                                            </v-layout>
                                            <v-divider></v-divider>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Max</div>
                                                <div>{{ max[header.value] }}</div>
                                            </v-layout>
                                            <v-layout justify-space-between class="pa-1 tooltips-info">
                                                <div>Min</div>
                                                <div>{{ min[header.value] }}</div>
                                            </v-layout>
                                        </div>
                                    </v-menu>
                                    <v-icon small>mdi-arrow-up</v-icon>
                                </v-layout>
                            </th>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
        <default-dialog :sender_name="selectedSenderName"></default-dialog>
    </div>

</template>

<script>
import ReportService from '@/services/report.service'
import utils from '@/services/utils'
import _ from 'lodash'
import moment from 'moment'
import DatePicker from '@/components/custom/DatePicker'
import BotService from '@/services/bot.service'
import { SocketMixin } from "@/mixins/SocketMixin";
import { mapState, mapActions } from "vuex";
import ActionTypes from "@/store/ActionTypes";
import StaffService from "@/services/staff.service";

export default {
    name: 'SessionInfo',
    components: {
        DatePicker,
        DefaultDialog: () => import(
            "@/components/dialog/Index"
        )
    },
    mixins: [SocketMixin],
    data() {
        return {
            supporterEmail: '',
            customerName: '',
            cif: '',
            topicLevel1: '',
            topicLevel2: '',
            fromDate: moment().subtract(6, 'day').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            today: moment().format('YYYY-MM-DD'),
            timeType: 'start_time',
            interval: '7days',
            density: 'daily',
            supporter: 'all',
            channel: 'all',
            activeBot: {},
            configuredTopics: [],
            dataTable: [],
            total_reports: 0,
            min: {},
            selectedSenderName: "",
            max: {},
            is_lock_report: false,
            supporterList: [
                { text: 'All', value: 'all' }
            ],
            channelList: [
                { text: 'All', value: 'all' }
            ],
            densityList: [
                { text: 'Daily', value: 'daily' },
                { text: 'Weekly', value: 'weekly' },
                { text: 'Monthly', value: 'monthly' }
            ],
            intervalList: [
                { text: 'Last 7 days', value: '7days' },
                { text: 'Last 30 days', value: '30days' },
                { text: 'Custom', value: 'custom' }
            ],
            timeTypeList: [
                { text: 'Filter by requested time', value: 'requested_time' },
                { text: 'Filter by assign time', value: 'start_time' },
                { text: 'Filter by first response time', value: 'first_response_time' },
                { text: 'Filter by end time', value: 'end_time' },
            ],
            pagination: {

            },
            rowsPerPageItems: [10, 20, 50, 100],
            loadingDialog: false,
            botList: [],
            crm_fields: [],
            collections: {},
            max_level: 0,
            headers_const: [
                {
                    text: 'No',
                    value: 'index',
                    sortable: true
                },
                {
                    text: 'Sender Id',
                    value: 'sender_id',
                    sortable: true
                },
                {
                    text: 'Conversation Id',
                    value: 'conversation_id',
                    sortable: true
                },
                {
                    text: 'Customer',
                    value: 'sender_name',
                    sortable: true
                },
                {
                    text: 'Supporter',
                    value: 'user.email',
                    $value: item => item.user.email,
                    sortable: true
                },
                {
                    text: 'Requested Time',
                    value: 'requested_time',
                    $value: item => item.requested_time ? this.dateFormat(item.requested_time) : "",
                    sortable: true
                },
                {
                    text: 'Session Source',
                    value: 'session_source',
                    $value: item => item.is_request_from_sender ? 'Customer Request' : 'Agent Proactive',
                    sortable: true
                },
                {
                    text: 'Assign Time',
                    value: 'created',
                    $value: item => this.dateFormat(item.start_time ? item.start_time : item.created),
                    sortable: true
                },
                {
                    text: 'First Response Time',
                    value: 'first_response_time',
                    $value: item => item.first_response_time ? this.dateFormat(item.first_response_time) : "",
                    sortable: true
                },
                {
                    text: 'End Time',
                    value: 'updated',
                    $value: item => this.dateFormat(item.end_time ? item.end_time : item.updated),
                    sortable: true
                },
                {
                    text: 'Handling Time',
                    value: 'handling_time',
                    $value: item => {
                        const endTime = item.end_time ? item.end_time : item.updated;
                        const assignTime = item.start_time ? item.start_time : item.created;
                        return endTime && assignTime ? this.timeFormatHHMMSS(new Date(endTime) - new Date(assignTime)) : "";
                    },
                    sortable: true
                },
                {
                    text: 'Customer Wait Time',
                    value: 'customer_wait_time',
                    $value: item => item.first_response_time && item.requested_time ? this.timeFormat(new Date(item.first_response_time) - new Date(item.requested_time)) : "",
                    sortable: true
                },
                {
                    text: 'Agent First Response Time',
                    value: 'agent_first_response_time',
                    $value: item => item.first_response_time && item.start_time ? this.timeFormat(new Date(item.first_response_time) - new Date(item.start_time)) : "",
                    sortable: true
                },
                {
                    text: 'Request Description',
                    value: 'description',
                    sortable: true
                },
                {
                    text: 'Session notes',
                    value: 'notes',
                    sortable: true
                },
                {
                    text: 'Topic',
                    value: 'topic',
                    $value: item => this.calculateValue(item, -1),
                    sortable: true
                },
                {
                    text: 'CIF',
                    value: 'cif',
                    sortable: false
                },
                {
                    text: 'Status',
                    value: 'state',
                    sortable: false,
                },
                {
                    text: 'Agent messages count',
                    value: 'agent_chatlog_count',
                    sortable: true
                },
                {
                    text: 'Customer messages count',
                    value: 'customer_chatlog_count',
                    sortable: true
                }
            ],
            headers: []
        }
    },
    computed: {
        ...mapState(['notifyBotChat', 'user']),
        topicLevel1Options() {
            if (this.configuredTopics.length > 0) {
                return this.configuredTopics.map(t => t.name);
            }
            return [...new Set(this.dataTable.map(item => {
                if (item.topic && typeof item.topic === 'object') return item.topic.level_1;
                return null;
            }).filter(Boolean))];
        },
        topicLevel2Options() {
            if (this.configuredTopics.length > 0) {
                if (!this.topicLevel1) return [];
                const found = this.configuredTopics.find(t => t.name === this.topicLevel1);
                return found ? found.children : [];
            }
            const rows = this.topicLevel1
                ? this.dataTable.filter(item => item.topic && item.topic.level_1 === this.topicLevel1)
                : this.dataTable;
            return [...new Set(rows.map(item => {
                if (item.topic && typeof item.topic === 'object') return item.topic.level_2;
                return null;
            }).filter(Boolean))];
        },
        isValidTimeRangeFilter() {
            return moment(this.toDate).diff(this.fromDate, 'days') < 90;
        },
        dataTableSort() {
            let clone = []
            if (this.dataTable.length) {
                clone = [...this.dataTable]
                clone = clone.map((items, index) => ({ ...items, index: index + 1 }))
            } else {
                return []
            }
            if (this.pagination.sortBy) {
                let header = _.find(this.headers, item => item.value === this.pagination.sortBy)
                clone = _.orderBy(
                    clone,
                    item => header.$value ? header.$value(item) : item[header.value],
                    this.pagination.descending ? 'desc' : 'asc'
                )
                clone = clone.map((items, index) => ({ ...items, index: index + 1 }))
                return clone
            }
            return clone
        }
    },
    async mounted() {
        const hasPermission = await this.hasPermission()
        if (hasPermission) {
            this.loadingDialog = true
            BotService.getAllBot().then(
                result => {
                    this.botList = result.data;
                    let botCode = this.$route.params.botCode
                    if (botCode) {
                        let bot = _.find(this.botList, bot => bot.code === botCode)
                        if (bot) {
                            this.selectBot(bot)
                        } else {
                            this.loadingDialog = false
                            this.$router.push('/session-info')
                        }
                    } else if (this.botList.length > 0) {
                        this.selectBot(this.botList[0])
                    } else {
                        this.loadingDialog = false
                    }
                },
            ).catch(() => {
                this.$AppService.handleRequestError('can not get bot list')
            });
        }
        else {
            this.$router.push('/forbidden')
        }
    },
    methods: {
        ...mapActions('dialog', ['openConversationHistoryBySession']),
        ...mapActions('notify', ['notifyCustomerProcess']),
        initBotStaffList() {
            if (this.botStaffList.length < 1) {
                this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
            }
        },
        async hasPermission() {
            return await StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5]);
        },
        handleClickConversationId(props) {
            this.selectedSenderName = props.item.sender_name
            this.openConversationHistoryBySession({ sessionId: props.item.session_id, user: props.item.user, updated: props.item.updated, botCode: this.$route.params.botCode, senderId: props.item.sender_id, senderChannel: props.item.channel })
        },
        async getData() {
            if (!this.isValidTimeRangeFilter) {
                this.$AppService.toastError("Excess maximum export limit (90 days)");
                return
            }
            if (this.activeBot.code) {
                await ReportService.SessionReportStatus(this.activeBot.code)
                    .then((res) => {
                        this.is_lock_report = res.data['is_lock']
                    })
                    .catch(e => {
                        this.$AppService.handleRequestError('Get lock report status failed')
                    });
                await ReportService.SessionInfo(this.activeBot.code, this.supporterEmail, this.timeType, this.toISOString(this.fromDate, true), this.toISOString(this.toDate), this.pagination.page, this.pagination.rowsPerPage, utils.removeVietnameseTones(this.customerName), this.cif, this.topicLevel1, this.topicLevel2)
                    .then(result => {
                        this.dataTable = result['data']['results'];
                        this.loadingDialog = false
                        this.total_reports = result.data.count;
                        this.max_level = result['data'].max_level;
                        this.headers = [...this.headers_const];
                        for (let i = 0; i < this.max_level; i++) {
                            this.headers.push({
                                text: `Topic Level ${i + 1}`,
                                value: `topic_level_${i}`,
                                $value: item => this.calculateValue(item, i),
                                sortable: true
                            })
                        }
                    }, () => {
                        this.$AppService.handleRequestError('can not get session info data')
                        this.loadingDialog = false
                    })
            }
        },
        calculateValue(item, i) {
            if (typeof item.topic === 'string' && i < 0) {
                return item.topic
            }
            else if (!!item.topic && typeof item.topic === 'object') {
                return item.topic[`level_${i + 1}`]
            }
            else {
                return "";
            }
        },
        toISOString(date, startOfDay) {
            return startOfDay ? moment(date).startOf('day').toISOString() : moment(date).endOf('day').toISOString()
        },
        dateFormat(date) {
            return moment(date).format('DD-MM-YYYY HH:mm:ss')
        },

        floor(value) {
            return Math.floor(value)
        },
        pad(value, numberOfDigits) {
            numberOfDigits = numberOfDigits || 2;
            return ('00' + value).slice(-numberOfDigits);
        },
        timeFormat(time) {
            var unitmapping = {
                "minutes": 60 * 1000,
                "seconds": 1000
            };
            let minutes = this.floor(time / unitmapping.minutes)
            let seconds = Math.round((time % unitmapping.minutes) / unitmapping.seconds)
            return minutes < 10 ? (this.pad(minutes) + ":" + this.pad(seconds)) : (minutes + ":" + this.pad(seconds));

        },
        timeFormatHHMMSS(time) {
            const totalSeconds = Math.floor(time / 1000);
            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;
            return this.pad(hours) + ':' + this.pad(minutes) + ':' + this.pad(seconds);
        },

        changeBot(bot) {
            this.$store.commit(ActionTypes.BOT, bot)
            this.$router.push('/session-info/' + bot.code)
        },
        selectBot(bot) {
            this.activeBot = bot
            this.getSessionReportConfig()
        },
        changeSort(headerValue) {
            let pagination = { ...this.pagination }
            if (pagination.sortBy === headerValue) {
                pagination.descending = !this.pagination.descending
            } else {
                pagination.sortBy = headerValue
                pagination.descending = true
            }
            this.pagination = pagination
            setTimeout(() => {
                this.$forceUpdate()
            }, 2000)
        },
        async exportExcel() {
            ReportService.SessionInfoExcel(this.activeBot.code, this.supporterEmail, this.timeType, this.toISOString(this.fromDate, true), this.toISOString(this.toDate), this.crm_fields, this.collections, utils.removeVietnameseTones(this.customerName), this.cif, this.topicLevel1, this.topicLevel2)
                .then(() => {
                    this.$AppService.toastSuccess("The report information version is being processed, you will receive report notification via email after a few minutes.")
                    this.is_lock_report = true
                }).catch(() => {
                    this.$AppService.toastError("Session Info Report Failed");
                });
        },
        getSessionReportConfig() {
            let botCode = this.$route.params.botCode;
            ReportService.getTopicOptions(botCode)
                .then(res => { this.configuredTopics = Array.isArray(res.data) ? res.data : []; })
                .catch(() => { this.configuredTopics = []; });
            Promise.all([
                BotService.getSessionReportConfig(botCode),
                BotService.getCRMCollection(botCode)
            ])
                .then((values) => {
                    this.crm_fields = values[0].data.config_data;
                    this.collections = values[1].data;
                    _.mapKeys(this.collections.built_in, (value, key) => {
                        if (_.includes(this.crm_fields, key)) {
                            this.headers_const.push({
                                text: key,
                                value: `customer_attributes.built_in.${key}`,
                                $value: item => item.customer_attributes && item.customer_attributes.built_in ? item.customer_attributes.built_in[key] : '',
                            })
                        }
                    });
                    _.mapKeys(this.collections.attributes, (value, key) => {
                        if (_.includes(this.crm_fields, key)) {
                            this.headers_const.push({
                                text: key,
                                value: `customer_attributes.attributes.${key}`,
                                $value: item => item.customer_attributes && item.customer_attributes.attributes ? item.customer_attributes.attributes[key] : '',
                            })
                        }
                    })
                }).then(() => {
                    this.getData()
                })
        },
        connectNotiChannelsOfBot(bot_code) {
            // connect channels notification of bot
            // check if subscribed, > unsubscribe
            if (this.$store.state.channelsNotiBot && this.$store.state.channelsNotiBot.state && this.$store.state.channelsNotiBot.state === "subscribed") {
                this.$store.state.channelsNotiBot.unsubscribe();
            }
            // connect channels notification
            let noti_bot_channel_name = this.$const.SOCKETCLUSTER_NOTI_CHANNEL.APP + bot_code;
            this.$store.state.channelsNotiBot = this.$store.state.scClient.subscribe(noti_bot_channel_name);
            this.$nextTick(function () {
                this.$store.state.channelsNotiBot.watch(data => {
                    this.$store.commit(this.$ActionTypes.NOTIFY_CUSTOMER_CHANNELS, data);
                    this.notifyCustomerProcess(data)
                })
            });
        },
    },
    watch: {
        interval(val) {
            let get_statistic = false
            switch (val) {
                case '7days':
                    this.fromDate = moment().subtract(6, 'day').format('YYYY-MM-DD')
                    this.toDate = this.today
                    get_statistic = true
                    break
                case '30days':
                    this.fromDate = moment().subtract(29, 'day').format('YYYY-MM-DD')
                    this.toDate = this.today
                    get_statistic = true
                    break
                default:
                    break
            }
            if (get_statistic) {
                this.getData()
            }

        },
        timeType(val) {
            this.getData();
        },
        topicLevel1(val) {
            this.topicLevel2 = '';
            this.getData();
        },
        topicLevel2(val) {
            this.getData();
        },
        pagination: {
            handler() {
                this.getData()
            }
        },
        '$route'() {
            let botCode = this.$route.params.botCode
            if (botCode) {
                let bot = _.find(this.botList, bot => bot.code === botCode)
                if (bot) {
                    this.selectBot(bot)
                    this.connectNotiChannelsOfBot(bot.code)
                }
            }
        },
        notifyBotChat(val) {
            if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.SESSION_REPORT_STATUS) {
                if (val.data.is_success) {
                    this.$AppService.toastSuccess("Excels report success. Please check email")
                }
                else {
                    this.$AppService.handleRequestError("Excels report failed. Please contact administrator")
                }
                this.is_lock_report = false
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../components/style/variables.scss";

.action-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding: 8px 0 8px 8px;
}

.header {
    background: #2a4e69;
    color: #fff;
    padding: 0 15px;
}

::v-deep table.v-table {
    thead th {
        padding: 12px 0 12px 12px;
    }

    tbody tr td {
        white-space: nowrap;
        padding: 12px 0 12px 12px;
    }
}

.header-tooltips {
    width: 240px;
    background: #1b3447;
    color: #fff;
    padding: 5px;

    &::v-deep hr {
        border-color: #2a4b64;
    }
}

.info-icon {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.54);
    ;
    caret-color: rgb(73, 119, 238);
}

.tooltips-info {
    div:first-child {
        color: #00afc8;
    }
}

::v-deep .v-list .active {
    background: #ccc;
}

.chat_view_loading {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 99999;
    align-items: center;
    text-align: center;
    padding-top: 27%;

    .loading_overlay {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        background-color: black;
        opacity: 0.2;
    }
}
</style>
